import React from "react";

/**
 * React 19 natively supports rendering <title>, <meta>, <link> inside components
 * and hoists them to <head>. No helmet library needed.
 */
export const SEO = ({
  title,
  description,
  path = "",
  image,
}) => {
  const fullTitle = title
    ? `${title} | CM Lindley`
    : "CM Lindley - Trusted Supplier for Builders & General Contractors Nationwide";
  const canonical = `https://cmlindleyllc.com${path}`;
  const desc =
    description ||
    "CM Lindley - Material Supply Specialists. Premium lumber, structural steel, and full job-site material packages for builders and general contractors.";

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </>
  );
};

export default SEO;
